// @flow
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl, IntlShape } from 'react-intl';
import { withConfirmation } from 'speed-js-react';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import MainActions from 'esm-web-pro/components/layout/sidePanel/MainActions';
import TimelineIcon from 'esm-web-pro/components/layout/sidePanel/icons/TimelineIcon';
import type { Match, RouterHistory } from 'react-router-dom';


type SidePanelActionProps = {
    openPanel: (key: string, url: ?string, skipSensitivity?: boolean) => { key: string, url: string },
    closePanel: (key: string, skipSensitivity: boolean) => { key: string },
}

type Props = {
    ...$Exact<SidePanelActionProps>,
    intl: IntlShape,
    history: RouterHistory,
    match: Match,
}

class SFPActions extends React.Component <Props> {
    static defaultProps: $Shape<Props>;

    getActions = () => {
        const {
            intl: { formatMessage }, match, history,
        } = this.props;
        const regex = /^(.+?)(\/+)$/gm;
        const actions = [];

        actions.push({
            key: 'sfp-timeline',
            icon: <TimelineIcon />,
            tooltip: formatMessage(actionMessages.timeline),
            callback: () => history.push(`${match.url.replace(regex, '$1')}/timeline/sfp`),
            marginVertical: '15px',
            radius: '0%',
            color: 'transparent',
        });

        return actions;
    };


    render() {
        return <MainActions main actions={this.getActions()} />;
    }
}

export default withRouter(
    withConfirmation(
        injectIntl(
            SFPActions,
        ),
    ),
);
